<section class="prf-extracurricular-activity-cards">
  @for (card of cards; track card.id) {
    <prf-extracurricular-activity-card [card]="card"></prf-extracurricular-activity-card>
  }
</section>
